module.exports = __webpack_public_path__ + "img/project-1.5c9f0f66.jpg";